import Head from './../components/Head.vue';
import { getUrlParams } from '@/plugins/utils';
import Link from '../components/aboutLink.vue';
import Footer from '../components/Footer.vue';
export default {
  components: {
    Head,
    Footer,
    Link
  },

  created() {
    this.getYearList();
    this.getDataList();
  },

  mounted() {},

  data() {
    return {
      menuId: this.$utils.getUrlParams('menuId'),
      input: '',
      checkIndex: 0,
      courseList: [],
      yearList: [{
        grade: 2025
      }, {
        grade: 2024
      }, {
        grade: 2023
      }, {
        grade: 2022
      }],
      checkYear: '',
      footerItem: null
    };
  },

  methods: {
    async getDataList() {
      const res = await this.$http.getDataList();
      this.dataList = res;
      this.footerItem = this.dataList.find(item => item.function_id == '10303');
    },

    async course_outline_page() {
      let res = await this.$http.course_outline_page({
        grade: this.checkYear,
        keyword: this.input,
        organ_id: ''
      });
      console.log(res, 'res');
      this.courseList = res || [];
    },

    // 获取年份列表
    async getYearList() {
      const res = await this.$http.getCourseOutlineYearList({
        type: 3
      });
      this.yearList = res && res.length && res.splice(0, 4) || [];

      if (this.yearList.length) {
        this.checkYear = this.yearList[0].grade;
      }

      this.course_outline_page();
    },

    changeYear(grade) {
      this.checkYear = grade;
      this.course_outline_page();
    }

  }
};